import React from "react";
import {
  KG_INSPECTOR_ICON_DEFAULT_SIZE,
  kgInspectorIcons,
} from "../../kg/canvas/inspector/kgInspectorIcons";
import { KgInspectorDetailRow } from "../KgInspectorDetailRow";
import { OverviewRoot } from "./KgInspectorArtifactOverview.styles";
import type { KgInspectorArtifactOverviewProps } from "./KgInspectorArtifactOverview.types";

const FormatIcon = kgInspectorIcons.format;
const SharedWithIcon = kgInspectorIcons.sharedWith;
const UpdatedOnIcon = kgInspectorIcons.updatedOn;

export const KgInspectorArtifactOverview: React.FC<
  KgInspectorArtifactOverviewProps
> = ({ overview }) => {
  const format = overview?.format ?? "";
  const sharedWith = overview?.sharedWith ?? "";
  const updatedOn = overview?.updatedOn ?? "";

  return (
    <OverviewRoot>
      {format ? (
        <KgInspectorDetailRow
          icon={
            <FormatIcon size={KG_INSPECTOR_ICON_DEFAULT_SIZE.format} />
          }
          label="Format"
          value={format}
        />
      ) : null}

      {sharedWith ? (
        <KgInspectorDetailRow
          icon={
            <SharedWithIcon size={KG_INSPECTOR_ICON_DEFAULT_SIZE.sharedWith} />
          }
          label="Shared with"
          value={sharedWith}
        />
      ) : null}

      {updatedOn ? (
        <KgInspectorDetailRow
          icon={
            <UpdatedOnIcon size={KG_INSPECTOR_ICON_DEFAULT_SIZE.updatedOn} />
          }
          label="Updated on"
          value={updatedOn}
        />
      ) : null}
    </OverviewRoot>
  );
};

export default KgInspectorArtifactOverview;
